import { Component } from '@angular/core';

@Component({
  selector: 'skeleton-sugerencias',
  templateUrl: 'skeleton-sugerencias.html'
})
export class SkeletonSugerenciasComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/skeleton-sugerencias/skeleton-sugerencias.ts